interface JWTPayload {
  site: string;
  profiles?: {
    user?: number;
    group?: number;
    charter?: number;
    sales?: number;
    coupon?: number;
  };
  user?: {
    id: number;
    email: string;
    name: string;
  };
  validatedReservations?: number[];
}

function decodeBase64Url(value: string): string {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");

  if (typeof atob === "function") {
    return atob(padded);
  }

  return Buffer.from(padded, "base64").toString("utf-8");
}

export function extractJWTPayload(token: string): JWTPayload | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;

    return JSON.parse(decodeBase64Url(parts[1])) as JWTPayload;
  } catch {
    return null;
  }
}

export function extractProfilesFromJWT(token: string): be.Profiles | null {
  const payload = extractJWTPayload(token);
  if (!payload) return null;

  return payload.profiles || {};
}
